"use strict";
/**

 * @description 改写自 alpha-cookie-info 2.0.2
 * @author zhangsen.z 
 * @version 1.0
 */

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _puck = require('@alife/puck');

var _puck2 = _interopRequireDefault(_puck);

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _storeProxy = require('./store-proxy/store-proxy');

var _storeProxy2 = _interopRequireDefault(_storeProxy);

var _indexSimple = require('./index-simple.js');

var _indexSimple2 = _interopRequireDefault(_indexSimple);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var STORE_KEY = 'cookie-info-storeproxy-ipdata';

var ipInfo = {

    /**
        获取用户IP信息 处理
     */
    _getIPData: function _getIPData(callback) {
        var ipDataUrl = '//www.alibaba.com/detail/ajax/queryIpAjax.do';
        if (typeof callback === 'function') {
            _puck2['default'].jsonp(ipDataUrl, {
                jsonp: 'jsonp'
            }).then(function (res) {
                var ipData = {},
                    storeVal = [];
                var resultData = res.body;
                if ((typeof resultData === 'undefined' ? 'undefined' : _typeof(resultData)) === 'object' && typeof resultData.countryCode === 'string') {
                    ipData.cityName = resultData.cityName;
                    ipData.countryCode = resultData.countryCode;
                    ipData.regionName = resultData.regionName;
                    ipData.updateTime = new Date().getTime();
                    ipData.success = true;
                    storeVal.push(ipData.cityName);
                    storeVal.push(ipData.countryCode);
                    storeVal.push(ipData.regionName);
                    storeVal.push(ipData.updateTime);
                    _storeProxy2['default'].set(STORE_KEY, storeVal.join('|'));
                    callback.call(this, ipData);
                }
            }.bind(this))['catch'](function (resultData) {
                callback.call(this, { success: false });
            }.bind(this));
        }
    },

    /**
        获取用户IP信息 处理
     */
    getIPData: function getIPData(callback) {

        _storeProxy2['default'].get(STORE_KEY, function (err, data) {
            var result = false;
            if (typeof data === 'string' && typeof callback === 'function') {
                var storeArr = data.split('|'),
                    ipData = {};
                if (storeArr.length === 4) {
                    ipData.cityName = storeArr[0];
                    ipData.countryCode = storeArr[1];
                    ipData.regionName = storeArr[2];
                    ipData.updateTime = Number(storeArr[3]);
                    var nowTime = new Date().getTime();
                    var diffTime = nowTime - ipData.updateTime;

                    //缓存半小时
                    if (diffTime < 30 * 60 * 1000 && diffTime > 0) {
                        result = true;
                        callback.call(this, ipData);
                    }
                }
            }
            if (result === false) {
                this._getIPData(callback);
            }
        }.bind(this));
    }
};

_indexSimple2['default'].getIPData = function (callback) {
    ipInfo.getIPData(callback);
};
_indexSimple2['default'].getCountryAlways = function (callback) {
    var ct = this.getCountry();
    if (typeof callback === 'function') {
        if (typeof ct === 'string' && ct !== '') {
            callback.call(this, ct);
        } else {
            ipInfo.getIPData(function (ipData) {
                if (ipData.success === false) {
                    if (this.getIsOversea() === true) {
                        callback.call(this, 'US');
                    } else {
                        callback.call(this, 'CN');
                    }
                } else {
                    callback.call(this, ipData.countryCode);
                }
            }.bind(this));
        }
    }
}.bind(_indexSimple2['default']);

exports['default'] = _indexSimple2['default'];
module.exports = exports['default'];